import { takeLatest } from 'redux-saga/effects';
import {
	getTicketReplyListSuccess, getTicketReplyListFail,
	getTicketReplyDetailsSuccess, getTicketReplyDetailsFail,
} from './ticketreplyState';

import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, LOADING_MSG,
	createRecordSuccess,
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/support/tickets');
const redirectData = { route: '/console/ticket-replies', mode: 'list', recordId: 0 };
const modelName = 'Ticket Reply';
const modelId = 'trp_id';

function* getTicketReplyList(data) {
	const { ticketId, ...params } = data.payload;
	const childEndpoint = `${ticketId}/ticket-replies`;
	const filters = { ...params, trp_ticket_id: ticketId };
	yield doCrudCall(
		() => crudService.getList(filters, childEndpoint ), 
		getTicketReplyListSuccess, 
		getTicketReplyListFail, null, null, LOADING_MSG
	);
}

function* getTicketReplyDetails(data) {
	const { ticketId, replyId } = data.payload;
	const childEndpoint = `${ticketId}/ticket-replies`;
	yield doCrudCall(
		() => crudService.getDetails(replyId, childEndpoint), 
		getTicketReplyDetailsSuccess,
		getTicketReplyDetailsFail,
		null,
		null,
		LOADING_MSG
	);
}

function* doTicketReplyCreate(data) {
  	const trp_ticket_id = data.payload.trp_ticket_id;
	const childEndpoint = `${trp_ticket_id}/ticket-replies`;
	yield doCrudCall(
		() => crudService.doCreate(data.payload, childEndpoint),
		getTicketReplyDetailsSuccess, 
		getTicketReplyDetailsFail,
		createRecordSuccess(modelName),
		{ ...redirectData, mode: 'reload' },
		SAVING_MSG
	);
}


function* ticketReplySaga() {
	yield takeLatest('ticketReply/getTicketReplyList', getTicketReplyList);
	yield takeLatest('ticketReply/getTicketReplyDetails', getTicketReplyDetails);
	yield takeLatest('ticketReply/doTicketReplyCreate', doTicketReplyCreate);
}

export default ticketReplySaga;
